import { render } from "./CargueInterco.vue?vue&type=template&id=bf6fe804&scoped=true"
import script from "./CargueInterco.vue?vue&type=script&lang=js"
export * from "./CargueInterco.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./CargueInterco.vue?vue&type=style&index=1&id=bf6fe804&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf6fe804"]])

export default __exports__